import ExternalApiRequest from '../externalApiRequest';
import APP from 'app';

const getFooterData = async () => {
    try {
        const options = {
            api: 'footer',
            content: { isB2C: APP.Utils.isB2cClient() }
        };
        return await ExternalApiRequest(options);
    } catch (error) {
        return '';
    }
};

export default getFooterData;
